import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SalaProvider } from './contexts/SalaContext';
import Sidebar from './components/Sidebar';
import AlertaVencidos from './components/AlertaVencidos';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Equipamentos from './pages/Equipamentos';
import Chamados from './pages/Chamados';
import Atendimentos from './pages/Atendimentos';
import Insumos from './pages/Insumos';
import Usuarios from './pages/Usuarios';
import Perfis from './pages/Perfis';
import AdminWhatsapp from './pages/AdminWhatsapp';
import AdminAtendimento from './pages/AdminAtendimento';
import Indicadores from './pages/Indicadores';
import Contatos from './pages/Contatos';
import Solicitacoes from './pages/Solicitacoes';
import UsoSistemas from './pages/UsoSistemas';
import Apresentacoes from './pages/Apresentacoes';
import AdminNotificacoes from './pages/AdminNotificacoes';
import Avisos from './pages/Avisos';
import VendasWeb from './pages/VendasWeb';
import AnaliseBanco from './pages/AnaliseBanco';
import AnaliseBancoRelatorio from './pages/AnaliseBancoRelatorio';
import AdminFluxos from './pages/AdminFluxos';
import Agentes from './pages/Agentes';
import MartelinhoConexao from './pages/MartelinhoConexao';
import MartelinhoIndicadores from './pages/MartelinhoIndicadores';
import MartelinhoUsuarios from './pages/MartelinhoUsuarios';
import MartelinhoHistorico from './pages/MartelinhoHistorico';
import MartelinhoFuncionalidades from './pages/MartelinhoFuncionalidades';
import BackupManager from './pages/BackupManager';
import Topologia from './pages/Topologia';
import Monitoramento from './pages/Monitoramento';
import Plataformas from './pages/Plataformas';
import Sala from './pages/Sala';
import Checklist from './pages/Checklist';
import Cameras from './pages/Cameras';

function FullScreenLoader() {
  return (
    <div className="screen-loader">
      <div className="screen-loader__spinner" />
      <p>Carregando Portal TI...</p>
    </div>
  );
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <FullScreenLoader />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function AppLayout({ children }) {
  return (
    <div className="layout">
      <Sidebar />
      <main className="main-content">{children}</main>
    </div>
  );
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/ti/dashboard" replace /> : <Login />} />

      {/* Modulo TI */}
      <Route
        path="/ti/dashboard"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Dashboard />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/equipamentos"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Equipamentos />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/chamados"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Chamados />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/atendimentos"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Atendimentos />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/atendimentos/indicadores"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Indicadores />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/contatos"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Contatos />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/solicitacoes"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Solicitacoes />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/insumos"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Insumos />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Modulo Admin */}
      <Route
        path="/admin/usuarios"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Usuarios />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/admin/perfis"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Perfis />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/admin/whatsapp"
        element={(
          <PrivateRoute>
            <AppLayout>
              <AdminWhatsapp />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/admin/atendimento"
        element={(
          <PrivateRoute>
            <AppLayout>
              <AdminAtendimento />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Analise do Banco de Dados: relatorio para imprimir (sem o menu) */}
      <Route
        path="/ti/analise-banco/relatorio/:tipo"
        element={(
          <PrivateRoute>
            <AnaliseBancoRelatorio />
          </PrivateRoute>
        )}
      />

      {/* Analise do Banco de Dados */}
      <Route
        path="/ti/analise-banco"
        element={(
          <PrivateRoute>
            <AppLayout>
              <AnaliseBanco />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Adocao do Vendas Web */}
      <Route
        path="/ti/vendas-web"
        element={(
          <PrivateRoute>
            <AppLayout>
              <VendasWeb />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Avisos da diretoria (operacao e sistemas) */}
      <Route
        path="/avisos"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Avisos />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Notificacoes automaticas */}
      <Route
        path="/admin/notificacoes"
        element={(
          <PrivateRoute>
            <AppLayout>
              <AdminNotificacoes />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Flow Builder - editor de fluxos do bot (RFC-001) */}
      <Route
        path="/admin/fluxos"
        element={(
          <PrivateRoute>
            <AppLayout>
              <AdminFluxos />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Backup Manager - backups agendados via SMB para local/Drive */}
      <Route
        path="/admin/backup"
        element={(
          <PrivateRoute>
            <AppLayout>
              <BackupManager />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Topologia da infraestrutura (KAN-291) */}
      <Route
        path="/ti/sala"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Sala />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/ti/topologia"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Topologia />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      {/* Monitoramento de infraestrutura (KAN-290) — proxy PromQL do Prometheus */}
      <Route
        path="/ti/monitoramento"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Monitoramento />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Plataformas do Hub Centrao (landing page compartilhada) */}
      <Route
        path="/admin/plataformas"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Plataformas />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Checklist diario/semanal da equipe de TI */}
      <Route
        path="/ti/checklist"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Checklist />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Cameras: tour ao vivo dos DVRs/NVRs */}
      <Route
        path="/ti/cameras"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Cameras />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Agentes instalados nas maquinas */}
      <Route
        path="/ti/agentes"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Agentes />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Martelinho (bot WhatsApp do ERP) */}
      <Route
        path="/martelinho/indicadores"
        element={(
          <PrivateRoute>
            <AppLayout>
              <MartelinhoIndicadores />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/martelinho/usuarios"
        element={(
          <PrivateRoute>
            <AppLayout>
              <MartelinhoUsuarios />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/martelinho/historico"
        element={(
          <PrivateRoute>
            <AppLayout>
              <MartelinhoHistorico />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/martelinho/funcionalidades"
        element={(
          <PrivateRoute>
            <AppLayout>
              <MartelinhoFuncionalidades />
            </AppLayout>
          </PrivateRoute>
        )}
      />
      <Route
        path="/martelinho/conexao"
        element={(
          <PrivateRoute>
            <AppLayout>
              <MartelinhoConexao />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Monitor de Uso dos Sistemas */}
      <Route
        path="/monitor/uso-sistemas"
        element={(
          <PrivateRoute>
            <AppLayout>
              <UsoSistemas />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      {/* Apresentacoes de Resultados */}
      <Route
        path="/apresentacoes"
        element={(
          <PrivateRoute>
            <AppLayout>
              <Apresentacoes />
            </AppLayout>
          </PrivateRoute>
        )}
      />

      <Route path="*" element={<Navigate to={user ? '/ti/dashboard' : '/login'} replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* SalaProvider acima do router: a chamada de voz/video sobrevive
            a troca de aba dentro do portal. Se estivesse dentro de Sala.js
            (ou em qualquer rota), sair de /ti/sala desmontaria o hook e
            derrubaria a conexao. */}
        <SalaProvider>
          <AppRoutes />
          <AlertaVencidos />
        </SalaProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
